import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calendar-bootstrap',
  templateUrl: './calendar-bootstrap.component.html',
  styleUrls: ['./calendar-bootstrap.component.scss']
})
export class CalendarBootstrapComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
